<template>
	<div>
		<label>{{ label }} <span v-if="mandatory" class="asterik">*</span></label>
		<div @mouseover="hovering = true" @mouseleave="hovering = false">
			<!-- nothing except w-100 n pointer -->
			<DatePicker
				ref="date"
				tabindex="0"
				class="w-100 pointer"
				:class="{
					'datefield-input': from != 'kanban',
					dateerror: showError,
				}"
				:placeholder="placeholder"
				:format="format"
				:value-type="format"
				:type="datetype"
				v-model="inputData"
				:disabled="disabled"
				:disabled-date="disabledDate"
				:disabled-time="disabledTime"
				@input="$emit('select-value', inputData)"
			/>
			<img
				v-if="icon != 'time'"
				@click.stop="openDatePicker"
				class="pointer p-update"
				src="@/assets/common/calender-icon.svg"
				alt=""
			/>
			<img
				v-else
				class="pointer p-update"
				@click.stop="openDatePicker"
				src="@/assets/common/time-icon.svg"
				alt=""
			/>
			<!-- <img
        :class="
          from == 'kanban' ? 'kanban-calendar-icons' : 'new-calender-class'
        "
        v-else
        @click.stop="openDatePicker"
        class="pointer"
        src="../../assets/new-calender-icon.svg"
        alt=""
      /> -->
		</div>
	</div>
</template>

<script>
export default {
	name: "DateField",
	data() {
		return {
			inputData: "",
			hovering: false,
		};
	},
	props: {
		fromCust: Boolean,
		noLabel: Boolean,
		disabled: Boolean,
		type: String,
		label: String,
		mandatory: Boolean,
		placeholder: String,
		id: String,
		showError: Boolean,
		format: String,
		from: String,
		icon: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
		disabledDate: {
			type: Function,
			default: null,
		},
		disabledTime: {
			type: Function,
			default: null,
		},
	},
	computed: {
		datetype() {
			if (
				this.format === "MM-DD-YYYY" ||
				this.format === "DD-MM-YYYY" ||
				this.format === "YYYY-MM-DD"
			) {
				return "date";
			} else if (
				this.format === "DD-MM-YYYY HH:mm:ss" ||
				this.format === "MM-DD-YYYY HH:mm:ss"
			) {
				return "datetime";
			} else if (this.format === "MM-YYYY") {
				return "month";
			} else if (this.format === "YYYY") {
				return "year";
			} else if (this.format === "HH:mm:ss" || this.format === "HH:mm") {
				return "time";
			}
			return "date";
		},
	},
	created() {
		if (this.vmodel) {
			this.inputData = this.vmodel;
		}
	},
	watch: {
		vmodel(val) {
			if (val) {
				this.inputData = val;
			}
		},
	},
	mounted() {
		document.addEventListener("click", this.handleClick);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.handleClick);
	},
	methods: {
		handleClick(event) {
			let minutePicker = document.querySelector('[data-type="minute"]');
			let datePickerContainer =
				document.getElementsByClassName("mx-datepicker-main")[0];
			if (minutePicker?.contains(event.target)) {
				datePickerContainer.style.display = "none";
			} else if (datePickerContainer) {
				datePickerContainer.style.display = "";
			}
		},

		openDatePicker() {
			this.$refs.date.$el.children[0].click();
		},
		clearInputData() {
			this.inputData = "";
			this.$emit("select-value", this.inputData);
		},
	},
};
</script>

<style>
.datefield-input > .mx-input-wrapper > .mx-icon-calendar {
	display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear {
	display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear:hover {
	display: none;
}

.topDiv > .dateerror .mx-input {
	border: 1px solid red !important;
	border-radius: 8px !important;
}
.dateerror .mx-input {
	border: 1px solid red !important;
	border-radius: 8px !important;
}
.topDiv > .datefield-input .mx-input {
	cursor: pointer;
}
.newmodalinputbox > .dateerror .mx-input {
	border: 1px solid red !important;
	border-radius: 8px !important;
}
.newmodalinputbox > .datefield-input .mx-input {
	cursor: pointer;
}

.new-calender-class {
	position: absolute;
	right: 15px;
	top: 11px;
}

.close-icon-class {
	position: absolute;
	right: 42px;
	top: 12px;
}

.topDiv > .datefield-input .mx-input:disabled {
	background: #f7f7f7 !important;
}

.disabled-pointer {
	cursor: not-allowed;
}

.mx-time-column .mx-time-list::after {
	display: none;
}

.date-picker-hidden {
	display: none;
}

.date-picker-visible {
	display: block;
}
.p-update {
	top: 34px;
	position: absolute;
	right: 26px;
}

.mx-input:disabled {
	background: #f5f5f5 !important;
}
</style>
